import { Typography } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import Button from '../Button';

type Props = {
  notes: string;
  maxLength?: number;
  rows?: number;
};

export const ExpandableNotes: FC<Props> = ({
  notes,
  maxLength = 100,
  rows = 3,
}) => {
  const { t } = useTranslation('common.ExpandableNotes');

  const [expanded, setExpanded] = useState(false);
  const shouldShowButton = notes.length > maxLength;

  const ellipsisConfig = expanded
    ? false
    : {
        rows,
        tooltip: notes,
      };

  return (
    <>
      <Typography.Paragraph
        ellipsis={ellipsisConfig}
        className={shouldShowButton ? styles.paragraphWithExpand : undefined}
      >
        {notes}
      </Typography.Paragraph>
      {shouldShowButton && (
        <Button
          type="link"
          size="small"
          onClick={() => setExpanded(!expanded)}
          className={styles.expandableButton}
        >
          {expanded ? t('showLess') : t('showMore')}
        </Button>
      )}
    </>
  );
};
